// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__v4UOn","iconWrapper":"Skill_iconWrapper__mOWMc","icon":"Skill_icon__VLY6B","title":"Skill_title__m3pUm","description":"Skill_description__4mt20"};